<template>
    <div class="kit-product__atts">
        <div>
            <label>Qty.</label>
            <p>
                <span v-if="!onEdit">{{ qtt }}</span>
                <ProductQuantity v-else :min="min" :max="max" :qtt="qtt" @update="updateCartQtt" />
            </p>
        </div>
    </div>
</template>

<script>
    import ProductQuantity from './ProductQuantity.vue';

    export default {
        name: 'ProductInlineQuantity',
        props: ['step', 'pid', 'onEdit'],
        components: {
            ProductQuantity
        },
        computed: {
            qtt() {
                return this.$store.state.cart[this.$store.state.kitId][this.step][this.pid].qtt;
            },
            min() {
                return this.$store.state.cart[this.$store.state.kitId][this.step][this.pid].product.min_qty;
            },
            max() {
                return this.$store.state.cart[this.$store.state.kitId][this.step][this.pid].product.max_qty;
            }
        },
        methods: {
            updateCartQtt(qtt) {
                const step = this.step;
                const pid = this.pid;
                
                this.$store.dispatch('updateCartItemQtt', {step, pid, qtt});
            }
        }
    }
</script>